import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import _ from 'lodash'
import ogImage from "../../images/posts/50/thumb-landscape.jpg"

import Slider from "react-slick";


const Post50 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,

    responsive: [
    {
      breakpoint: 1024,
      settings: {
      slidesToShow: 2,
      slidesToScroll: 2,
      }
    },
    {
      breakpoint: 599,
      settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      }
    }
  ]    
  };

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">CELINE／ベルトバッグマイクロ／24 x20 x13cm</span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>CELINE（セリーヌ）の次なるアイコンバッグと言われている BELT BAG（ベルトバッグ）をご存知でしょうか？<br></br>フラップの左右から伸びる長いレザーストラップが特徴的な BELT BAG（ベルトバッグ）2014年の登場以来、シンプルなシルエットで豊富なカラー展開、5つのサイズ、3wayで使用できるデザインが大人女子に人気のバッグです。<br></br>今回は、それぞれのサイズ感やおすすめコーディネートをご紹介していきます。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2>目次</h2>
        <p>
          <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80}>1.BELT BAG（ベルトバッグ）の特徴</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80}>2.BELT BAG（ベルトバッグ）の5つのサイズ展開</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec3" smooth={true} duration={500} offset={-80}>3.BELT BAG（ベルトバッグ）の3つの持ち方</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec4" smooth={true} duration={500} offset={-80}>4.BELT BAG（ベルトバッグ）のおすすめコーデ</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec5" smooth={true} duration={500} offset={-80}>5.まとめ</ScrollLink><br></br>
        </p>
      </div>               
      <div name="sec1" className="text-max-width">
        <h2>1.BELT BAG（ベルトバッグ）の特徴</h2>
        <figure>
          <StaticImage src="../../images/posts/50/1.jpg" alt="CELINE（セリーヌ）の次なるアイコンバッグ♡ BELT BAG（ベルトバッグ）"/>
        </figure>         
        <span className="text-center">写真はNANO BELT BAG（ナノベルトバッグ）</span>
        <p>トップハンドルと、取り外し可能なショルダーストラップ付きで、2wayでの使用が可能。トップフラップとジッパーの両方で閉じることができます。また、マチがしっかりあるので収納力も抜群でガバッと間口が開くのも使いやすいポイントです。<br></br><br></br>PICO（ピコ）NANO（ナノ）サイズは、クロージャー部分がマグネットでストラップの調整が可能です。</p>
        <figure>
          <StaticImage src="../../images/posts/50/2.jpg" alt=""/>
        </figure>
        <span className="text-center">写真はPICO BELT BAG（ピコベルトバッグ）</span>
        <p>マグネットクロージャー。</p>
        <figure>
          <StaticImage src="../../images/posts/50/3.jpg" alt=""/>
        </figure> 
        <p>ストラップの調節が可能。<br></br><br></br>MICRO（マイクロ）MINI（ミニ）SMALL（スモール）はフックタイプのクロージャーです。（ストラップの長さ調節はできません）</p>
        <figure>
          <StaticImage src="../../images/posts/50/4.jpg" alt=""/>
        </figure> 
        <span className="text-center">写真は SMALL BELT BAG（スモールベルトバッグ）</span>
        <p>フックタイプのクロージャー。</p>                                
      </div>
      <Link to="https://laxus.co/app/pc/bags/celine" className="view-all-button">
       CELINEのバッグを見る
      </Link>      
      <div name="sec2" className="text-max-width">
        <h2>2.BELT BAG（ベルトバッグ）の5つのサイズ展開</h2> 
        <figure>
          <StaticImage src="../../images/posts/50/5.jpg" alt=""/>
        </figure>         
        <p>サイズは小さい順に、PICO（ピコ）NANO（ナノ）MICRO（マイクロ）MINI（ミニ）SMALL（スモール）となっており、一番大きいサイズがSMALL（スモール）という少しややこしいサイズ展開です。
        </p>
        <h2>■PICO BELT BAG（ピコベルトバッグ） /15×13×8cm(幅×高さ×マチ)</h2>
        <figure>
          <StaticImage src="../../images/posts/50/6.jpg" alt=""/>
        </figure>
        <p>5つの中で一番小さいサイズ。留め具はマグネットで、ストラップの長さ調節が可能です。</p>  
        <figure>
          <StaticImage src="../../images/posts/50/7.jpg" alt=""/>
        </figure>
        <p>iPhone 12 Pro Maxと比較してみました。小さいながらも、マチがあるので横にするとバッグに収納可能です♡<br></br>ミニバッグトレンドの流れもあり、豊富なカラー展開から選ぶのも楽しいですね。<br></br>一部ですが、紹介しております。</p> 
        <Slider className="slide-box" {...settings}>
          <StaticImage src="../../images/posts/50/8.jpg"/>
          <StaticImage src="../../images/posts/50/9.jpg"/>
          <StaticImage src="../../images/posts/50/10.jpg"/>
          <StaticImage src="../../images/posts/50/11.jpg"/>
          <StaticImage src="../../images/posts/50/12.jpg"/>
        </Slider>
        <h2>■NANO BELT BAG（ナノベルトバッグ） /20×17×10cm(幅×高さ×マチ)</h2>
        <figure>
          <StaticImage src="../../images/posts/50/13.jpg" alt=""/>
        </figure>
        <p>NANO（ナノ）は一般的なミニバッグといった印象でしょうか？<br></br>こちらもマグネットクロージャー。調節＆取り外し可能のストラップ付きです。</p>
        <figure>
          <StaticImage src="../../images/posts/50/14.jpg" alt=""/>
        </figure>
        <h2>■MICRO BELT BAG（マイクロベルトバッグ） /24×20×13cm(幅×高さ×マチ)</h2>
        <figure>
          <StaticImage src="../../images/posts/50/15.jpg" alt=""/>
        </figure>
        <p>MICRO（マイクロ）は、ナノよりひと回り大きいサイズ。長財布は余裕で入ります！A4サイズは入らないので、デイリーに使いやすいサイズですね。</p>
        <h2>■MINI BELT BAG（ミニベルトバッグ） /28×22×16cm(幅×高さ×マチ)</h2>
        <figure>
          <StaticImage src="../../images/posts/50/16.jpg" alt=""/>
        </figure>
        <p>通勤にも使いたい！という方におすすめサイズのMINI（ミニ）。A4サイズも収納可能でお仕事バッグとしても◎</p>
        <h2>■SMALL BELT BAG（スモールベルトバッグ） /31×26×18cm(幅×高さ×マチ)</h2>
        <figure>
          <StaticImage src="../../images/posts/50/17.jpg" alt=""/>
        </figure>
        <p>BELT BAG（ベルトバッグ）の中で1番大きいサイズのSMALL（スモール）。CELINE（セリーヌ）では、現在販売が終了しているので希少なバッグです。1泊旅行にも使えそうなたっぷり収納可能なサイズです。</p>
      </div>        
      <Link to="https://laxus.co/app/pc/bags/celine" className="view-all-button">
       CELINEのバッグを見る
      </Link>                                                          
      <div name="sec3" className="text-max-width">
        <h2>3.BELT BAG（ベルトバッグ）の3つの持ち方</h2>
        <h2>■ハンドバッグ</h2>
        <p>トップハンドルを持ってハンドバッグとして。</p>   
        <figure>
          <StaticImage src="../../images/posts/50/18.jpg"/>
        </figure>
        <h2>■ショルダーバッグ</h2>
        <p>ストラップでショルダーに。</p>   
        <figure>
          <StaticImage src="../../images/posts/50/19.jpg"/>
        </figure>
        <h2>■クラッチバッグ</h2>
        <p>写真のような持ち方でクラッチとして持っても◎。</p>   
        <figure>
          <StaticImage src="../../images/posts/50/20.jpg"/>
        </figure>                
      </div>                              
      <div name="sec4" className="text-max-width">
        <h2>4.BELT BAG（ベルトバッグ）のおすすめコーデ</h2>
        <figure className="img-small">
          <StaticImage src="../../images/posts/50/21.png"/>
        </figure>
        <span className="text-center">カジュアルにお出かけ用として。</span> 
        <figure className="img-small">
          <StaticImage src="../../images/posts/50/22.png"/>
        </figure>
        <span className="text-center">お仕事には書類も入るMINI（ミニ）で♡</span>                         
      </div>                                                   
      <div name="sec5" className="text-two-cloumn">
        <h2>5.まとめ</h2>
        <p>いかがでしたか？BELT BAG（ベルトバッグ）はCELINE（セリーヌ）らしいシンプルで上質でカラー展開も豊富です。<br></br>ぜひ一度使ってみてはいかがでしょうか？</p>
      </div>
      <Link to="https://laxus.co/app/pc/bags/celine" className="view-all-button">
       CELINEのバッグを見る
      </Link>
    </section>
    <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post50

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 50}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
